/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Linux_1Inputs */

const en_pc_dl_linux_1 = /** @type {(inputs: Pc_Dl_Linux_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Easiest: make the AppImage executable and run it: chmod +x pdfcraft-*.AppImage && ./pdfcraft-*.AppImage`)
};

const zh_pc_dl_linux_1 = /** @type {(inputs: Pc_Dl_Linux_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最简单：赋予 AppImage 执行权限后运行：chmod +x pdfcraft-*.AppImage && ./pdfcraft-*.AppImage`)
};

/**
* | output |
* | --- |
* | "Easiest: make the AppImage executable and run it: chmod +x pdfcraft-*.AppImage && ./pdfcraft-*.AppImage" |
*
* @param {Pc_Dl_Linux_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_linux_1 = /** @type {((inputs?: Pc_Dl_Linux_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Linux_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_linux_1(inputs)
	return zh_pc_dl_linux_1(inputs)
});
export { pc_dl_linux_1 as "pc.dl.linux.1" }